import EditPackType from "./Edit";

export default function AddPackType() {
  return <EditPackType mode="add" />;
}

